import * as React from "react";
const SvgDragV = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 8, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22,4v8m0,8v8m0,8v8m0,8v8M42,4v8m0,8v8m0,8v8m0,8v8" }));
export default SvgDragV;
